import './navigation.scss'

class MobileNavigation {
    constructor() {
        this.toggleButton = document.querySelector('.o-header__mobileToggle');
        this.navigationContainer = document.querySelector('.o-header__navigation');
        this.mobileOverlay = document.querySelector('.m-navigation__mobileOverlay');
        this.mobileDrawer = document.querySelector('.m-navigation__mobileDrawer');
        this.mobileCloseButton = document.querySelector('.m-navigation__mobileClose');
        this.body = document.body;
        this.html = document.documentElement;
        this.isOpen = false;
        this.scrollY = 0;
        
        if (this.toggleButton && this.navigationContainer) {
            this.init();
        }
    }

    init() {
        // Toggle button click
        this.toggleButton.addEventListener('click', () => this.toggle());
        
        // Close button click
        if (this.mobileCloseButton) {
            this.mobileCloseButton.addEventListener('click', () => this.close());
        }
        
        // Overlay click to close
        if (this.mobileOverlay) {
            this.mobileOverlay.addEventListener('click', () => this.close());
        }
        
        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });
        
        // Close on window resize if menu is open and we're above mobile breakpoint
        window.addEventListener('resize', () => {
            if (this.isOpen && window.innerWidth >= 992) {
                this.close();
            }
        });
        
        // Close when clicking on a link
        const mobileLinks = this.navigationContainer.querySelectorAll('a');
        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                // Small delay to allow navigation to start
                setTimeout(() => this.close(), 100);
            });
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        // Save current scroll position
        this.scrollY = window.scrollY;
        
        this.navigationContainer.classList.add('-isOpen');
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.body.classList.add('-menuOpen');
        this.body.style.top = `-${this.scrollY}px`;
        
        // Focus management - focus first link in mobile menu
        const firstLink = this.navigationContainer.querySelector('a');
        if (firstLink) {
            setTimeout(() => firstLink.focus(), 100);
        }
    }

    close() {
        this.isOpen = false;
        this.navigationContainer.classList.remove('-isOpen');
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.body.classList.remove('-menuOpen');
        this.body.style.top = '';
        
        // Restore scroll position
        window.scrollTo(0, this.scrollY);
        
        // Return focus to toggle button
        this.toggleButton.focus();
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new MobileNavigation();
    });
} else {
    new MobileNavigation();
}